import React, { useState } from 'react'
import Load from '../Load/Load'
import { message, Button } from 'antd'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { editCase } from '../../Web Apis/webApis'
// import { MdSignalWifiStatusbar1Bar } from 'react-icons/md'


const EditCase = ({ showModal, setShowModal, selectedCase, action, setAction }) => {

    const [open, setOpen] = useState(showModal)
    const [loading, setLoading] = useState(false)
    

    const closeEditModal = () => {
        setOpen(false)
        setShowModal(false)
    }


    const formik = useFormik({
        initialValues: {
            caseStatus: selectedCase.status,
        },
        validationSchema: Yup.object({
            // firstName: Yup.string().required("First name is required").max(15, "First name should not be more than 15 characters").min(2, "Fist name should be atleast 2 characters long").trim("First name should not have spaces").matches(/^[a-zA-Z\s]*$/, "First name should not contain special characters or numbers"),
            // lastName: Yup.string().required("Last name is required").max(15, "Last name should not be more than 15 characters").min(2, "Fist name should be atleast 2 characters long").trim("Last name should not have spaces").matches(/^[a-zA-Z\s]*$/, "Last name should not contain special characters or numbers"),
            // email: Yup.string().email("Invalid email format").required("Email is required").trim(),
            // companyLogo: Yup.string().required("Company logo is required"),
            // // startSubscription: Yup.string().required("Subscription start date is required"),
            // // endSubscription: Yup.string().required("Subscription end date is required"),
            // person_number: Yup.string().required("Phone number is required").matches(/^\d{6,15}$/, "Phone number must be between 6 and 15 digits"),
            // person_email: Yup.string().email("Please enter a valid email address").required("Contact person email is required").trim().matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, "Please enter a valid email address"
            // ),
            // companyName: Yup.string().required("Company name is required").max(50, "Company name should not be more than 50 characters").min(3, "Company name should be atleast 3 characters long").trim("Company name should not have spaces"),
            // address: Yup.string().required("Address is required").max(200, "Address should not be more than 200 characters").min(10, "Address should be atleast 10 characters long").trim("Address should not have spaces"),
        }),

        onSubmit: async (values, { resetForm, setSubmitting }) => {
            setLoading(true)
            try {

                const response = await editCase(
                    selectedCase.id,
                   values.caseStatus
                )

                if (response?.data?.success) {
                    message.success(response?.data?.message);
                    resetForm()
                    setOpen(false)
                    setShowModal(false)
                    setAction(!action)
                }

            } catch (error) {
                console.log("Error while edit admin", error.message)
                message.error(error?.response?.data?.message || "Error while edit admin profile")
            } finally {
                setSubmitting(false)
                setLoading(false)
            }
        }
    })




    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white  rounded-lg shadow-lg w-[400px] h-[320px] overflow-y-auto">
                <h3 className="text-xl font-bold mb-1 text-center bg-gradient-to-br from-teal-950 to-teal-500 py-2 text-white">
                    Update Case Status
                </h3>
                <form onSubmit={formik.handleSubmit} className='p-8'>
                  

                    <div className="w-full mt-2">
                        <label className="block">
                            Status:
                            <select
                                name="active"
                                value={formik.values.caseStatus} // Bind to the "status" field
                                onChange={(e) => {

                                    formik.setFieldValue('caseStatus',e.target.value)
                                }}
                                onBlur={formik.handleBlur}
                                className="block w-full p-3 border border-gray-800 bg-white rounded-md mt-1"
                            >
                                <option value="Pending">Pending</option>
                                <option value="In Progress">In Progress</option>
                                <option value="Completed">Completed</option>
                            </select>
                        </label>
                    </div>


                    
                    <div className="flex justify-end gap-6 mt-20">
                        <button onClick={closeEditModal} className="bg-gray-300 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200">
                            Close
                        </button>

                        <button type="submit" className="bg-blue-500 text-white py-2 px-4 rounded-md w-52 hover:bg-blue-600 transition duration-200 mr-2">
                            {formik.isSubmitting ? "Updating..." : "Update"}
                        </button>

                    </div>
                </form>
            </div>
            {loading && <Load/>}
        </div>
    )
}

export default EditCase